export default __webpack_public_path__ + "static/media/logo.a46e7531.svg";